const ONLY_DIGITS_REGEX = /^\d+$/;

const normalizeCode = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

export const compareAccountsByCode = (a = {}, b = {}) => {
  const codeA = normalizeCode(a.code);
  const codeB = normalizeCode(b.code);

  const numericA = ONLY_DIGITS_REGEX.test(codeA);
  const numericB = ONLY_DIGITS_REGEX.test(codeB);

  if (numericA && numericB) {
    const diff = Number(codeA) - Number(codeB);
    if (diff !== 0) return diff;
    return codeA.length - codeB.length;
  }

  if (numericA) return -1;
  if (numericB) return 1;

  if (codeA && codeB) {
    const lex = codeA.localeCompare(codeB, "es", { sensitivity: "base" });
    if (lex !== 0) return lex;
  } else if (codeA) {
    return -1;
  } else if (codeB) {
    return 1;
  }

  const nameA = (a.name || "").toString();
  const nameB = (b.name || "").toString();
  return nameA.localeCompare(nameB, "es", { sensitivity: "base" });
};

export const sortAccountsByCode = (accounts = []) =>
  [...(accounts || [])].sort(compareAccountsByCode);
